import { cn } from "@/lib/utils";

export function Logo({ className, mark = true }) {
  return (
    <div className={cn("flex items-center gap-2 select-none", className)} data-testid="nxt-logo">
      {mark && (
        <div className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 text-white font-display font-extrabold text-lg shadow-lg shadow-indigo-600/30">
          N
          <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-amber-400 ring-2 ring-white" />
        </div>
      )}
      <span className="font-display text-xl font-extrabold tracking-tight">
        Nx<span className="text-indigo-600">T</span>
      </span>
    </div>
  );
}
